import Cookies from 'js-cookie';
import ReactGA from 'react-ga4'

const MEASUREMENT_ID = "2YJ4V8TQME";
const GA_MEASUREMENT_ID = `G-${MEASUREMENT_ID}`;


const GA_COOKIES = ["_ga", "_gid", "_gat", `_ga_${MEASUREMENT_ID}`];
export const CONSENT_COOKIE = "gaImmoblesAcceptCookie";

const domains = [
    "immobiliariagarrotxaactiva.cat",
    ".immobiliariagarrotxaactiva.cat",
    "www.immobiliariagarrotxaactiva.cat",
    "immobiliariagarrotxaactiva.com",
    ".immobiliariagarrotxaactiva.com",
    "www.immobiliariagarrotxaactiva.com",
    "localhost"
];

// Referencia original al setter de document.cookie
const originalCookieDescriptor = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie')
    || Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');

let cookiesBlocked = false;


export function getCookiesStatus() {
    const cookies = Cookies.get();
    return Object.keys(cookies).some((name) => name.startsWith("_ga") || name.startsWith("_gcl"));
}

export async function acceptCookies() {
    try {
        // Restaurar el setter original de document.cookie si estaba bloqueado
        if (cookiesBlocked && originalCookieDescriptor) {
            Object.defineProperty(document, 'cookie', originalCookieDescriptor);
            cookiesBlocked = false;
        }

        Cookies.set(CONSENT_COOKIE, "true", { path: "/", expires: 365 });
        ReactGA.initialize(GA_MEASUREMENT_ID);
    } catch (error) {
        console.error("Error al acceptar les cookies:", error);
        return false;
    }

    return true;
}


function isTrackingCookie(name) {
    return name.startsWith("_ga") || name.startsWith("_gcl") || name.startsWith("_gid") || name.startsWith("_gat");
}

function removeGACookies() {
    const allCookies = document.cookie.split(";").map(c => c.trim().split("=")[0]);
    const cookiesToRemove = allCookies.filter(isTrackingCookie);

    const allNames = [...new Set([...GA_COOKIES, ...cookiesToRemove])];
    allNames.forEach((name) => {
        // Sin dominio (cookie del dominio actual)
        originalCookieDescriptor.set.call(document, `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`);
        // Con cada dominio configurado
        domains.forEach((domain) => {
            originalCookieDescriptor.set.call(document, `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain};`);
        });
    });
}

function blockTrackingCookies() {
    if (!originalCookieDescriptor) return;

    Object.defineProperty(document, 'cookie', {
        configurable: true,
        get: function () {
            return originalCookieDescriptor.get.call(this);
        },
        set: function (val) {
            // Extraer el nombre de la cookie del string "nombre=valor;..."
            const cookieName = val.split("=")[0].trim();
            // Bloquear solo cookies de tracking, dejar pasar las demás
            if (isTrackingCookie(cookieName)) {
                return;
            }
            originalCookieDescriptor.set.call(this, val);
        }
    });
    cookiesBlocked = true;
}


export function declineCookies() {
    try {
        // 1. Desactivar GA mediante su propio flag
        window[`ga-disable-${GA_MEASUREMENT_ID}`] = true;

        // 2. Revocar consentimiento via gtag (antes de sobreescribirlo)
        if (window.gtag) {
            window.gtag("consent", "update", { analytics_storage: "denied" });
        }

        // 3. Vaciar dataLayer y anular gtag
        window.dataLayer = [];
        window.gtag = function () { };

        // 4. Eliminar scripts de GA del DOM
        document.querySelectorAll('script[src*="googletagmanager"], script[src*="google-analytics"]').forEach(el => el.remove());

        // 5. Resetear react-ga4
        ReactGA.reset();

        // 6. Eliminar cookies de tracking existentes
        removeGACookies();

        // 7. Interceptar document.cookie para BLOQUEAR que GA recree cookies de tracking
        blockTrackingCookies();

        // 8. Limpiezas adicionales por si algún timer de GA aún dispara
        setTimeout(removeGACookies, 200);
        setTimeout(removeGACookies, 1000);

        Cookies.set(CONSENT_COOKIE, "false", { path: "/", expires: 365 });

    } catch (error) {
        console.error("Error al rebutjar les cookies:", error);
        return false;
    }

    return true;
}
